/**
 * DevCardBadge Component
 *
 * Wrapper that shows a small badge with the component name on hover.
 * Only visible in dev environment (import.meta.env.DEV), completely
 * tree-shaken out of production builds.
 */

import type { ReactNode } from "react";

interface DevCardBadgeProps {
  name: string;
  children: ReactNode;
}

export function DevCardBadge({ name, children }: DevCardBadgeProps) {
  const isDev = typeof import.meta !== 'undefined' && Boolean(import.meta.env?.DEV);
  if (!isDev) return <>{children}</>;

  return (
    <div className="relative group/devbadge">
      {children}
      <span className="absolute top-1 right-1 z-50 hidden group-hover/devbadge:inline-block rounded bg-fuchsia-600/90 px-1.5 py-0.5 text-[10px] font-mono text-white pointer-events-none shadow-sm">
        {name}
      </span>
    </div>
  );
}
